import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "../components/inputControls/inputField";
import FileUpload from "../components/inputControls/fileUpload";
import DropdownSelect from "../components/inputControls/selecteField";
import CheckboxField from "../components/inputControls/checkBoxField";
import "../styles/requestcertificate.css";
import Header from "../components/header";
import { get, post } from "../config/api";
import { Loader } from "../components/loader";
import TextArea from "../components/inputControls/textarea";
import { useDispatch } from "react-redux";
import { setErrorFlag } from "../store/slices/errorConfig";
import Broken from "./broken";
import { configConstants, MH_CODE, userType } from "../constants/textconstants";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Stack, Drawer } from "@mui/material";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { Upload, Delete } from "../constants";
import { ConfirmationModal } from "../components/confirmationModal";
import { API_ENDPOINTS } from "../config/apiEndpoints";
import Webcam from "react-webcam";

dayjs.extend(localizedFormat);

interface Option {
  id: string | number;
  label: string;
}

interface RequestUpdatesProps {}

export const RequestCertificatePage: React.FC<RequestUpdatesProps> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { request } = location.state;
  const [applicationId, setApplicationId] = useState<string>("");
  const [shopName, setShopName] = useState(request.shop_name || "");
  const [gstNumber, setGstNumber] = useState<string>("");
  const [licenseNumber, setLicenseNumber] = useState<string>("");
  const [shopAddress, setShopAddress] = useState<string>("");
  const [shopPincode, setShopPincode] = useState<string>("");
  const [godownAddress, setGodownAddress] = useState<string>("");
  const [godownPincode, setGodownPincode] = useState<string>("");
  const [issueDate, setIssueDate] = useState<dayjs.Dayjs | null>(null);
  const [expiryDate, setExpiryDate] = useState<dayjs.Dayjs | null>(null);
  const [productList, setProductList] = useState<Option[]>([]);
  const [distributorList, setDistributorList] = useState<Option[]>([]);
  const [selectedDistributor, setSelectedDistributor] = useState<Option[]>([]);
  const [selectedRetailer, setSelectedRetailer] = useState<Option[]>([]);
  const [selectedProducts, setSelectedProducts] = useState<Option[]>([]);
  const [shopDistrict, setShopDistrict] = useState<Option | null>(null);
  const [godownDistrict, setGodownDistrict] = useState<Option | null>(null);
  const [noExpiry, setNoExpiry] = useState<boolean>(false);
  const [sameAsShop, setSameAsShop] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [liscenceFileUrls, setLiscenceFileUrls] = useState<string[]>([]);
  const fileUploaderRef = useRef<any>(null);
  const [liscenceFile, setLiscenceFile] = useState<string>(
    "http://example.com/license1"
  );
  const [state, setState] = useState<string>("");
  const [districts, setDistrict] = useState<Option[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showPageNotWorking, setShowPageNotWorking] = useState<boolean>(false);
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isNewEastGTM, setIsNewEastGTM] = useState(false);
  const [isRetailerUser, setIsRetailerUser] = useState(false);

  // Camera and Upload Modal State
  const [isUploadOptionOpen, setIsUploadOptionOpen] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [capturedImage, setCapturedImage] = useState<string | null>(null);
  const webcamRef = useRef<Webcam>(null);

 // console.log(request, "456787654r56789");

  const handleFileUploadClick = () => {
    if (fileUploaderRef.current) {
      fileUploaderRef.current.openFileDialog();
    }
  };

  const handleFilesSelected = (files: FileList) => {
    setSelectedFiles(Array.from(files));
  };

  const removeFile = (fileToRemove: File) => {
    setSelectedFiles(selectedFiles.filter((file) => file !== fileToRemove));
  };

  // New handlers for camera and upload options
  const handleUploadAreaClick = () => {
    setIsUploadOptionOpen(true);
  };

  const handleUploadFromGallery = () => {
    setIsUploadOptionOpen(false);
    handleFileUploadClick();
  };

  const handleCameraOption = () => {
    setIsUploadOptionOpen(false);
    setIsCameraOpen(true);
  };

  const handleCloseCamera = () => {
    setIsCameraOpen(false);
    setCapturedImage(null);
  };

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current?.getScreenshot();
    if (imageSrc) {
      setCapturedImage(imageSrc);
    }
  }, [webcamRef]);

  const retake = () => {
    setCapturedImage(null);
  };

  const dataURLtoFile = (dataurl: string, filename: string) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)?.[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const confirmCapture = () => {
    if (capturedImage) {
      const file = dataURLtoFile(capturedImage, `camera_capture_${Date.now()}.jpeg`);
      setSelectedFiles((prev) => [...prev, file]);
      handleCloseCamera();
    }
  };

  const uploadFiles = async () => {
    let userId = await localStorage.getItem("USER_ID");
    let timestamp = Date.now();
    if (selectedFiles.length === 0) {
      alert("Please select files to upload.");
      return [];
    }

    setIsUploading(true);

    const validFiles = selectedFiles.filter(
      (file) => file.size <= 5 * 1024 * 1024
    );
    const invalidFiles = selectedFiles.filter(
      (file) => file.size > 5 * 1024 * 1024
    );

    if (invalidFiles.length > 0) {
      alert(
        `The following files exceed the 5MB limit and will not be uploaded: ${invalidFiles
          .map((f) => f.name)
          .join(", ")}`
      );
      setIsLoading(false);
    }

    if (validFiles.length === 0) {
      setIsUploading(false);
      setIsLoading(false);
      return [];
    }

    try {
      const uploadedKeys = await Promise.all(
        validFiles.map(async (file) => {
          try {
            const res = await get(
              API_ENDPOINTS.GET_LICENSE_PRESIGNED_URL(
                file.name,
                file.type,
                userId,
                timestamp
              )
            );

            const { uploadUrl, fileUrl } = res;
            if (uploadUrl && fileUrl) {
              await fetch(uploadUrl, {
                method: "PUT",
                body: file,
                headers: { "Content-Type": file.type },
              });
              return fileUrl;
            }
          } catch (error) {
            console.error(`Failed to upload file ${file.name}:`, error);
            return null;
          }
          return null;
        })
      );
      const successfulUploads = uploadedKeys.filter(
        (key) => key !== null
      ) as string[];
      setIsUploading(false);
      return successfulUploads;
    } catch (error) {
      console.error("File upload error:", error);
      alert("Failed to upload one or more files. Please try again.");
      setIsUploading(false);
      return [];
    }
  };

  const handleIssueDateChange = (date: dayjs.Dayjs | null) => {
    if (date && date.isAfter(dayjs())) {
      alert("Issue date cannot be a future date");
      setIssueDate(null);
      return;
    }
    if (expiryDate && date && date.isAfter(expiryDate)) {
      alert("Issue date cannot be after expiry date");
      setIssueDate(null);
    } else {
      setIssueDate(date);
    }
  };

  const handleExpiryDateChange = (date: dayjs.Dayjs | null) => {
    if (issueDate && date && date.isBefore(issueDate)) {
      alert("Expiry date cannot be before issue date");
      setExpiryDate(null);
    } else {
      setExpiryDate(date);
    }
  };

  const handleNoExpiryChange = () => {
    const newNoExpiry = !noExpiry;
    setNoExpiry(newNoExpiry);
    if (newNoExpiry) {
      setExpiryDate(null);
    }
  };

  const [errors, setErrors] = useState({
    licenseNumber: false,
    expiryDate: false,
    issueDate: false,
    selectedProducts: false,
    shopAddress: false,
    shopPincode: false,
    godownAddress: false,
    godownPincode: false,
    license_issued_date: false,
    license_expired_date: false,
    license_copy_url: false,
    selectedRetailer: false,
    shopName: false,
    applicationId: false,
    godownDistrict: false,
    shopDistrict: false,
    selectedDistributor: false,
  });

  useEffect(() => {
    if (sameAsShop) {
      setGodownAddress(shopAddress);
      setGodownPincode(shopPincode);
      setGodownDistrict(shopDistrict);
    }
  }, [sameAsShop, shopAddress, shopPincode, shopDistrict]);

  useEffect(() => {
    const isDistributorSelected = isNewEastGTM || !isRetailerUser || selectedDistributor.length > 0;
    const applicationIdRegex = /^DOA[A-Z]ID\d{10,11}$/;
    const isApplicationIdValid = state !== MH_CODE || (!!applicationId.trim() && applicationIdRegex.test(applicationId));
    const isLicenseDetailsValid =
      !!licenseNumber.trim() && !!issueDate && (!!expiryDate || noExpiry);
    const isShopDetailsValid =
      !!shopAddress.trim() && !!shopPincode.trim() && !!shopDistrict;
    const isGodownDetailsValid =
      sameAsShop ||
      (!!godownAddress.trim() && !!godownPincode.trim() && !!godownDistrict);
    const areProductsSelected = selectedProducts.length > 0;
    const isLicenseFileUploaded = liscenceFileUrls.length > 0;
    const isRetailerMandatory = !request.fromHome;
    const isShopNameMandatory = !request.fromHome;
    const isRetailerSelected = isRetailerMandatory
      ? selectedRetailer.length > 0
      : true;
    const isShopNameValid = isShopNameMandatory
      ? shopName.trim() == ""
        ? false
        : true
      : false;
    const hasNoErrors = Object.values(errors).every((error) => error === false);

    if (!request.fromHome) {
      setIsFormValid(
        isDistributorSelected &&
        isShopNameValid &&
          isRetailerSelected &&
          isApplicationIdValid &&
          isLicenseDetailsValid &&
          isShopDetailsValid &&
          isGodownDetailsValid &&
          areProductsSelected &&
          (isLicenseFileUploaded || selectedFiles.length > 0) &&
          hasNoErrors
      );
    } else {
      
      setIsFormValid(
        isDistributorSelected &&
        isApplicationIdValid &&
          isLicenseDetailsValid &&
          isShopDetailsValid &&
          isGodownDetailsValid &&
          areProductsSelected &&
          (isLicenseFileUploaded || selectedFiles.length > 0) &&
          hasNoErrors
      );
    }
  }, [
    selectedDistributor,
    selectedRetailer,
    shopName,
    state,
    applicationId,
    licenseNumber,
    issueDate,
    expiryDate,
    noExpiry,
    shopAddress,
    shopPincode,
    shopDistrict,
    sameAsShop,
    godownAddress,
    godownPincode,
    godownDistrict,
    selectedProducts,
    liscenceFileUrls,
    selectedFiles,
    errors,
  ]);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    //console.log( selectedDistributor.map((product) => product.id), "selectedDistributor");
    const newErrors = {
      selectedDistributor: !isNewEastGTM && isRetailerUser && selectedDistributor.length === 0,
      applicationId: state === MH_CODE && (!applicationId.trim() || !/^DOA[A-Z]ID\d{10,11}$/.test(applicationId)),
      licenseNumber: !licenseNumber.trim(),
      issueDate: !issueDate,
      expiryDate: !expiryDate && !noExpiry,
      selectedProducts: selectedProducts.length === 0,
      shopAddress: !shopAddress.trim(),
      shopDistrict: !shopDistrict,
      shopPincode: !shopPincode.trim(),
      godownAddress: !sameAsShop && !godownAddress.trim(),
      godownPincode: !sameAsShop && !godownPincode.trim(),
      license_copy_url: liscenceFileUrls.length === 0 && selectedFiles.length === 0,
      selectedRetailer: !request.fromHome && selectedRetailer.length === 0,
      shopName: !request.fromHome && shopName.trim() === "",
      godownDistrict: !sameAsShop && !godownDistrict,
      license_issued_date: !issueDate,
      license_expired_date: !expiryDate && !noExpiry,
    };

    setErrors(newErrors);

    const formIsValid = !Object.values(newErrors).some(error => error);

    if (!formIsValid) {
      const errorFieldMapping: { [key: string]: string } = {
        selectedDistributor: "select-your-distributor",
        applicationId: "application-id",
        selectedRetailer: "select-retailer-distributor",
        shopName: "shop-name-as-per-license",
        licenseNumber: "pesticides-license-number",
        issueDate: "pesticides-license-issue-date",
        expiryDate: "license-expiry-date",
        license_copy_url: "pesticides-license-copy",
        selectedProducts: "products-for-certificate",
        shopAddress: "shop-address",
        shopDistrict: "shop-district",
        godownDistrict: "godown-district",
        godownAddress: "godown-address",
      };

      const firstError = Object.keys(newErrors).find(key => newErrors[key as keyof typeof newErrors]);

      if (firstError) {
        const elementId = errorFieldMapping[firstError];
        if (elementId) {
          const element = document.getElementById(elementId);
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      dispatch(setErrorFlag({ isError: true, errorMsg: "Please fill all mandatory fields marked with *" }));
      return;
    }
    setShowConfirmationModal(true);
  };

  const confirmSubmission = async () => {
    setIsLoading(true);
    setShowConfirmationModal(false);
    if (selectedFiles.length > 0 && liscenceFileUrls.length === 0) {
      const uploadedUrls = await uploadFiles();
      //console.log(uploadedUrls, "-------uploadedUrls");
      if (uploadedUrls.length === 0) {
        console.error(
          "File upload failed. we wont be able to proceed with the submission"
        );
        return;
      }
      let formData = {
        partner_id: localStorage.getItem("USER_ID") || "mock-user-id",
        // distributor_id: selectedDistributor[0]?.id || "",
        govt_application_number: applicationId,
        gst_number: gstNumber,
        license_number: licenseNumber,
        license_issued_date: issueDate
          ? dayjs(issueDate).format("YYYY-MM-DD")
          : "",
        license_expiry_date: expiryDate
          ? dayjs(expiryDate).format("YYYY-MM-DD")
          : null,
        license_documents: uploadedUrls.map((url) => ({
          document_url: url,
          document_key: url,
        })),
        products: selectedProducts.map((product) => product.id),
        shop_address: shopAddress,
        shop_district: shopDistrict?.label,
        shop_pincode: shopPincode,
        godown_address: sameAsShop ? shopAddress : godownAddress,
        godown_district: sameAsShop
          ? shopDistrict?.label
          : godownDistrict?.label,
        godown_pincode: sameAsShop ? shopPincode : godownPincode,
        godown_same_as_shop: sameAsShop,
        firm_name: shopName || request.name || "",
        distributor_ids: (isNewEastGTM || !isRetailerUser) ? [] : selectedDistributor.map((product) => product.id ),
        state_code: state,
      };
      //console.log(formData);
      let data = JSON.stringify(formData);
      try {
        
        const response = await post(
          API_ENDPOINTS.CREATE_CERTIFICATE_REQUEST,
          data
        );

        setIsLoading(false);
        const result = response;
       // console.log("API Response:", result);
        if (!response) {
          dispatch(
            setErrorFlag({
              isError: true,
              errorMsg: "Request couldn’t be submitted due to a technical issue. Please try again later.",
            })
          );
          return;
        }
        if (request.fromHome) {
          navigate(-1);
        } else {
          navigate(-1);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error submitting form:", error);
       dispatch(
            setErrorFlag({
              isError: true,
              errorMsg: "Request couldn’t be submitted due to a technical issue. Please try again later.",
            })
          );
      }
      setIsLoading(false);
    }
  };

  const fetchPartnerDetails = async () => {
    let USER_STATE = await localStorage.getItem(configConstants.USER_STATE);
    let parameters: any = {
      countryCode: configConstants.countryCode,
      stateCode: USER_STATE,
    };
    fetchDistrictDetails(parameters);
    setIsLoading(false);
  };

  const fetchDistrictDetails = async (parameters: any) => {
    setIsLoading(true);
    try {
      let response = await get(
        API_ENDPOINTS.GET_DISTRICTS(
          parameters.countryCode,
          parameters.stateCode
        )
      );
      if (response) {
        setIsLoading(false);
        if (response.length > 0) {
          let district: Option[] = [];
          response.map((item: any) => {
            district.push({ id: item.code, label: item.name });
          });
          setDistrict(district);
          if (request.address?.shop_district) {
            const shopDistrictValue = district.find(
              (d) =>
                d.label.toLowerCase() ===
                request.address.shop_district.toLowerCase()
            );
            if (shopDistrictValue) setShopDistrict(shopDistrictValue);
          }
          if (request.address?.godown_district) {
            const godownDistrictValue = district.find(
              (d) =>
                d.label.toLowerCase() ===
                request.address.godown_district.toLowerCase()
            );
            if (godownDistrictValue) setGodownDistrict(godownDistrictValue);
          }
        }
      }
    } catch (error) {
      setShowPageNotWorking(true);
      setIsLoading(false);
      console.error("Error fetching requests:", error);
    }
  };

  const fetchDistributorData = async (userId: any | null) => {
    try {
      setIsLoading(true);
      const response = await get(API_ENDPOINTS.GET_DISTRIBUTORS(userId));
      if (response && Array.isArray(response)) {
        const distributors = response.map((item: any) => ({
          id: item.partner_id,
          label: item.name,
        }));
        setDistributorList(distributors);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching distributors:", error);
    }
  };

  const fetchInitailData = async () => {
    let userId = await localStorage.getItem("USER_ID");
    fetchPartnerDetails();
    fetchDistributorData(userId);
    let USER_STATE = await localStorage.getItem(configConstants.USER_STATE);

    // Check unit_code for IN57
    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      const parsed = JSON.parse(storedUserData);
      if (['IN57'].includes(parsed?.unit)) setIsNewEastGTM(true);
      if (parsed?.partner_type?.toLowerCase() === userType.RETAILER) setIsRetailerUser(true);
    }

    if (USER_STATE) {
      setState(USER_STATE);
    }
  };

  const fetchProducts = async (districtCode: string | number, stateCode: string) => {
    let userId = await localStorage.getItem("USER_ID");
    try {
      setIsLoading(true);
      const response = await get(
        API_ENDPOINTS.GET_PRODUCTS(userId, configConstants.countryCode, districtCode, stateCode)
      );
      if (response.length >= 0) {
        const result = response;
        let newProductList: any = [];
        result.map((item: any) => {
          newProductList.push({
            id: item.product_name,
            label: item.product_name,
          });
        });
        setProductList(newProductList);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setShowPageNotWorking(true);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchInitailData();
    if (request && request.address) {
      setShopAddress(request.address.shop_address);
      setShopPincode(request.address.shop_pincode);
      setGodownAddress(request.address.godown_address);
      setGodownPincode(request.address.godown_pincode);
      setSameAsShop(request.address.godown_same_as_shop);
    }
  }, []);

  useEffect(() => {
    if (shopDistrict && state) {
      setSelectedProducts([]);
      fetchProducts(shopDistrict.id, state);
    }
  }, [shopDistrict]);

  const handleHelpClick = () => navigate("/help");
  const handleBackClick = () => window.history.back();
  return (
    <div className="page-container">
      {isLoading && <Loader />}
      {showPageNotWorking && <Broken />}
      <Header
        title="Request Certificate"
        actionText="Need Help?"
        onActionClick={handleHelpClick}
        onBackClick={handleBackClick}
      />
      <div className="request-page">
        <p className="brp-details">
          Enter details for BRP ID: {request.partner_id}
        </p>
        <p className="enterprise-name">{request.shop_name?request.shop_name: request.name}</p>
        <form onSubmit={handleSubmit}>
          
          {!request.fromHome && (
            <DropdownSelect
              id="select-retailer-distributor"
              hasError={errors.selectedRetailer}
              label="Select Retailer/Distributor"
              options={districts}
              selected={selectedRetailer}
              setSelected={setSelectedRetailer}
              placeholder="Select Retailer/Distributor"
            />
          )}
         
            <InputField
              id="shop-name-as-per-license"
              maxLength={200}
              hasError={errors.shopName}
              label="Shop Name (as per license) "
              placeholder="Enter shop name as per the license"
              value={shopName}
              onChange={(e) => setShopName(e.target.value)}
            />
          

            {state === MH_CODE && (
              <InputField
                id="application-id"
                isMH={state==MH_CODE}
                hasError={errors.applicationId}
                maxLength={20}
                validationRegex={/^DOA[A-Z]ID\d{10,11}$/}
                label="Application ID "
                placeholder="Request ID from Govt. portal"
                value={applicationId}
                onChange={(e) => setApplicationId(e.target.value.toUpperCase())}
              />
            )}


          <InputField
            maxLength={20}
            validationRegex={
              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
            }
            label="GST Number"
            placeholder="Enter GST no. if applicable"
            value={gstNumber}
            onChange={(e) => setGstNumber(e.target.value)}
          />
          <InputField
            maxLength={50}
            hasError={errors.licenseNumber}
            label="Pesticides License Number "
            placeholder="Enter no. as per the license"
            value={licenseNumber}
            onChange={(e) => setLicenseNumber(e.target.value)}
          />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack spacing={2} sx={{ marginBottom: 2 }}>
              <div id="pesticides-license-issue-date" className="form-group">
                <label
                  style={{
                    fontSize: 14,
                    display: "block",
                    marginBottom: 10,
                    fontWeight: 600,
                  }}
                >
                  Pesticides License Issue Date{" "}
                  <mark style={{ background: "transparent", color: "red" }}>
                    *
                  </mark>
                </label>
                <DatePicker
                  sx={{ width: "100%" }}
                  value={issueDate}
                  onChange={handleIssueDateChange}
                  slotProps={{
                    textField: {
                      placeholder: "Select Issue Date",
                      error: errors.license_issued_date,
                    },
                  }}
                  maxDate={dayjs()}
                  format="DD/MM/YYYY"
                  label={"Select Issue Date"}
                />
              </div>

              <div id="license-expiry-date" className="form-group">
                <label
                  style={{
                    fontSize: 14,
                    display: "block",
                    marginBottom: 10,
                    fontWeight: 600,
                  }}
                >
                  Pesticides License Expiry Date{" "}
                  <mark style={{ background: "transparent", color: "red" }}>
                    *
                  </mark>
                </label>
                <DatePicker
                  sx={{ width: "100%" }}
                  value={expiryDate}
                  onChange={handleExpiryDateChange}
                  slotProps={{
                    textField: {
                      placeholder: "Select Expiry Date",
                      error: errors.license_expired_date,
                    },
                  }}
                  minDate={dayjs()}
                  disabled={noExpiry}
                  format="DD/MM/YYYY"
                  label={"Select Expiry Date"}
                />
              </div>
            </Stack>
          </LocalizationProvider>

          <CheckboxField
            label="No Expiry Date"
            checked={noExpiry}
            onChange={handleNoExpiryChange}
          />

          <label
            id="pesticides-license-copy"
            style={{
              fontSize: 14,
              display: "block",
              marginBottom: 0,
              fontWeight: 600,
            }}
          >
            Pesticides License copy{" "}
            <mark style={{ background: "transparent", color: "red" }}>*</mark>
          </label>
          <span className="info-text-address">
            Helps us verify that your business is authorised to sell pesticides.
          </span>
          <FileUpload
            ref={fileUploaderRef}
            onFileSelect={handleFilesSelected}
            maxFileSizeMB={5}
            allowedFileTypes={[".png", ".jpeg", ".jpg", ".pdf"]}
          />
          <div
            className="upload-area"
            style={{
              border: errors.license_copy_url
                ? "1px dashed red"
                : "1px dashed #007cbf",
            }}
            onClick={handleUploadAreaClick}
          >
            <img
              src={Upload}
              className="upload-icon"
              style={{ height: 30 }}
              alt="upload"
            />
            {selectedFiles.length === 0 ? (
              <p className="click-to-upload">Click here to upload files</p>
            ) : (
              <div>
                <p className="click-to-upload">{selectedFiles.length} file(s) selected</p>
              </div>
            )}
            <p className="upload-note">JPG, PNG or PDF (max. 5 MB per file)</p>
          </div>
          <div style={{ marginTop: "10px", marginBottom: 20 }}>
            {selectedFiles.map((file, index) => (
              <div
                key={index}
                style={{
                  boxShadow:
                    "2px 2px 5px #f1f1f1, -2px -2px 5px rgb(255 255 255 / 50%)",
                  display: "flex",
                  marginBottom: "5px",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "20px 10px",
                  border: "1px solid #efefef",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={Upload}
                    className="upload-icon"
                    style={{ height: 30, marginRight: 20 }}
                    alt="upload"
                  />
                  <span
                    style={{
                      display: "block",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      width: 100,
                      overflow: "hidden",
                      fontSize: 13,
                    }}
                  >
                    {file.name}
                  </span>
                </div>
                <img
                  onClick={() => removeFile(file)}
                  src={Delete}
                  className="upload-icon"
                  style={{ height: 26, marginRight: 20 }}
                  alt="upload"
                />
              </div>
            ))}
          </div>
         
          <TextArea
            id="shop-address"
            hasError={errors.shopAddress}
            label="Shop Address "
            placeholder="Enter your shop address"
            value={shopAddress}
            onChange={(e) => setShopAddress(e.target.value)}
            maxLength={500}
          />

          <div className="address-row">
            <DropdownSelect
              id="shop-district"
              hasError={errors.shopDistrict}
              label="District"
              options={districts}
              selected={shopDistrict ? [shopDistrict] : []}
              setSelected={(option) => setShopDistrict(option[0])}
              placeholder="District"
              description="Choose the district where your shop is located."
            />
            <InputField
              maxLength={6}
              hasError={errors.shopPincode}
              label=""
              placeholder="Pincode"
              value={shopPincode}
              onChange={(e) => setShopPincode(e.target.value)}
            />
          </div>

          <label id="godown-address" style={{ fontSize: 14, display: "block", marginBottom: 10, fontStyle: 'normal',
fontWeight: '600',
lineHeight: '157%',
letterSpacing: '0.1'}}>
            Godown Address{" "}
          </label>
          <CheckboxField
            label="Same as shop address"
            checked={sameAsShop}
            onChange={() => setSameAsShop(!sameAsShop)}
          />
          <TextArea
            hasError={errors.godownAddress}
            placeholder="Enter your godown address"
            value={godownAddress}
            onChange={(e) => setGodownAddress(e.target.value)}
            disabled={sameAsShop}
            maxLength={500}
          />

          <div className="address-row">
            <DropdownSelect
              id="godown-district"
              label="District"
              hasError={errors.godownDistrict}
              options={districts}
              selected={godownDistrict ? [godownDistrict] : []}
              setSelected={(option) => setGodownDistrict(option[0])}
              placeholder="District"
              disabled={sameAsShop}
              description="Choose the district where your shop is located."
            />
            <InputField
              validationRegex={/^\d+$/}
              maxLength={6}
              hasError={errors.godownPincode}
              label=""
              placeholder="Pincode"
              value={godownPincode}
              onChange={(e) => setGodownPincode(e.target.value)}
              disabled={sameAsShop}
            />
          </div>
           {!isNewEastGTM && isRetailerUser && (
            <DropdownSelect
              id="select-your-distributor"
              hasError={errors.selectedDistributor}
              label="Select Your Distributor"
              options={distributorList}
              selected={selectedDistributor}
              setSelected={setSelectedDistributor}
              placeholder="Select Your Distributor"
              showSelectAll={false}
              description="Select the distributors from whom you currently buy or plan to buy Bayer products."
            />
          )}
          <DropdownSelect
            id="products-for-certificate"
            hasError={errors.selectedProducts}
            label="Products for Certificate "
            options={productList}
            selected={selectedProducts}
            setSelected={setSelectedProducts}
            placeholder="Select product"
            disabled={!shopDistrict}
            displayValue={
              selectedProducts.length > 0 &&
              selectedProducts.length === productList.length
                ? "All Products Selected"
                : undefined
            }
          />
          {request.fromHome ? (
            <button
              type="submit"
              className="submit-button"
              style={{ backgroundColor: "#007cbf" }}
            >
              Submit Request
            </button>
          ) : (
            <button
              type="submit"
              className="next-button"
              style={{ backgroundColor: "#007cbf" }}
            >
              Next
            </button>
          )}
        </form>
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          godownAddress={godownAddress+', '+  (godownDistrict ? godownDistrict.label:' ') + ', '+godownPincode}
          onAccept={confirmSubmission}
          onDecline={() => setShowConfirmationModal(false)}
        />
      )}
      <Drawer
        anchor="bottom"
        open={isUploadOptionOpen}
        onClose={() => setIsUploadOptionOpen(false)}
      >
        <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button className="submit-button" style={{ backgroundColor: "#007cbf", width: '100%' }} onClick={handleUploadFromGallery}>
            Upload from Gallery
          </button>
          <button className="submit-button" style={{ backgroundColor: "#007cbf", width: '100%' }} onClick={handleCameraOption}>
            Open Camera
          </button>
        </div>
      </Drawer>

      {isCameraOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 9999, backgroundColor: 'black', display: 'flex', flexDirection: 'column' }}>
          {!capturedImage ? (
            <>
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={{ facingMode: "environment" }}
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
              <button 
                onClick={capture}
                style={{ position: 'absolute', bottom: 30, left: '50%', transform: 'translateX(-50%)', width: 60, height: 60, borderRadius: '50%', backgroundColor: 'white', border: '4px solid #ccc' }}
              />
              <button 
                onClick={handleCloseCamera}
                style={{ position: 'absolute', top: 20, right: 20, color: 'white', background: 'transparent', border: 'none', fontSize: 18 }}
              >
                Close
              </button>
            </>
          ) : (
            <>
              <img src={capturedImage} alt="Captured" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              <div style={{ position: 'absolute', bottom: 30, left: 0, right: 0, display: 'flex', justifyContent: 'space-around' }}>
                <button onClick={retake} style={{ padding: '10px 20px', backgroundColor: 'white', border: 'none', borderRadius: 5 }}>Retake</button>
                <button onClick={confirmCapture} style={{ padding: '10px 20px', backgroundColor: '#007cbf', color: 'white', border: 'none', borderRadius: 5 }}>Use Photo</button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
